<template>
    <div id="removeclass">
       <app-modal
        :modal-id="modalId"
        modal-alignment="top"
        modal-size="fullscreen"
        @close-modal="closeModal"
      >
         <template slot="header">
           <div class="d-flex justify-content-between align-items-center w-100">
             <!-- Left: Modal Title -->
             <h5 class="modal-title mb-0">{{ modalTitle }}</h5>

             <!-- Right: Buttons -->
             <div>
               <button
                   v-if="active == 1"
                   type="button"
                   class="btn btn-secondary mr-2"
                   data-dismiss="modal"
                   @click="closeModal"
               >
                 {{ $t("close") }}
               </button>
               <button
                   v-if="active == 1"
                   type="button"
                   class="btn btn-primary"
                   @click="ignoreAll"
               >
                 {{ $t("ignore_all") }}
               </button>
             </div>
           </div>
         </template>

         <template slot="body">
          <div class="row">
            <div class="col-sm-12">
              <!-- <dynamic-form :id="id" :type="type" :tableId="tableId" :closemodal="closeModal"></dynamic-form> -->
              <div v-if="active != 1" class="mb-2">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-if="active < 4"> <a href="" @click.prevent="previous">Back</a></el-breadcrumb-item>
                  <el-breadcrumb-item v-if="active == 2">View</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <el-form v-if="active === 1">
                <app-table
                :id="tableId"
                :options="options"
                @action="getListAction"/>
              </el-form>
              <el-form v-if="active === 2">
                
                <div class="row">
                  <div class="col-sm-12">
                    <form-preview :back="previous" :id="formBody" :form_revision_id="formRevisionId" :form_id="formID" :response="formType"></form-preview>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </template>
      </app-modal>
    </div>
     
    </template>
    
    <script>
    import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
    import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
    import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
    import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
    import * as actions from "../../../../Config/ApiUrl";
    // import ThemeMixin from "../../../../../core/mixins/global/ThemeMixin";
    
    export default {
      name: "FormBuilderModal",
      mixins: [FormMixin, ModalMixin, TableHelpers],
      props: {
        type: String,
      },
      data() {
        return {
          show: true,
          active: 1,
          formType: '',
          formRevisionId: 0,
          formBody: 0,
          preloader: false,
          modalId: "demo-form-log-Modal",
          modalTitle: this.$t("form_log"),
          tableId: "advance-table",
          rowData: {},
          options: {
            name: "AdvanceTable",
            url: actions.FORM_CHANGES_LIST+'/'+this.type,
            // url: actions.DATATABLE_DATA,
            showHeader: true,
            columns: [
              // {
              //     title: this.$t('date'),
              //     type: 'media-object',
              //     key: 'media-object',
              //     mediaTitleKey: 'name',
              //     mediaSubtitleKey: 'email',
              //     default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
              //     modifier: (value, row) => {
              //         return value; // imag url
              //     },
              //     isVisible: true
              // },
              {
                title: this.$t("name"),
                type: "custom-html",
                key: "form_revision_list",
                modifier: (value,row) => {
                  return `<a class="text-primary cursor-pointer" id="${row.form_revision_list.id+'_'+row.form_revision_list.form_id+'_'+row.form_revision_list.form_body_id}"  @click.prevent=${this.myFunction(row)}>${this.$t(value.form_changes_name.name ?? "---")}</a>`;
                },
              },
              {
                title: this.$t("message"),
                type: "custom-html",
                key: "message",
                modifier: (value) => {    
                  return `<span>${this.$t(value ?? "---")}</span>`;
                },
              },
            //   {
            //     title: this.$t("created_by"),
            //     type: "custom-html",
            //     key: "get_bodies",
            //     modifier: (value) => {
                  
            //       let now = new Date();
            //       var date = moment(value.created_at ?? now).format("YYYY-MM-DD");
            //       return `<span> ${this.$t(value != null  ? value.created_by != null ? value.created_by.full_name : '---' : '---')}  </span> <br> <span> ${this.$t(date)}  </span>`;
            //     },
            //   },
            //   {
            //     title: this.$t("updated_by"),
            //     type: "custom-html",
            //     key: "get_bodies",
            //     modifier: (value) => {
            //       let now = new Date();
            //       var date = moment(value.updated_at ?? now).format("YYYY-MM-DD");
            //       return `<span> ${this.$t(value!= null ? value.updated_by != null ? value.updated_by.full_name : '---' : '---')}  </span> <br> <span> ${this.$t(date)}  </span>`;            },
            //   },
            //   {
            //     title: this.$t("status"),
            //     type: "custom-html",
            //     key: "active",
            //     isVisible: true,
            //     modifier: (value) => {
            //       let ClassName = "danger";
            //       let text;
    
            //       if (value == 1) 
            //       {
            //         ClassName = `success`;
            //         text = `Active`;
            //       }
            //       else 
            //       {
            //         text = `Inactive`;
            //       }
    
            //       return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
            //         text
            //       )}</span>`;
            //     },
            //   },
            //   {
            //     title: this.$t("version"),
            //     type: "custom-html",
            //     key: "version",
            //     modifier: (value) => {
    
            //       return `<span>${this.$t(value.toString() == '1' ? '1.0' : value.toString())}</span>`;
            //     },
            //   },
              {
                title: this.$t("status"),
                type: "custom-html",
                key: "form_change_log_status",
                isVisible: true,
                modifier: (value) => {
                  let ClassName = "danger";
                  let text;
    
                  if (value.status == 'accepted') 
                  {
                    ClassName = `success`;
                    text = `accepted`;
                  }
                  else if (value.status == 'ignored')
                  {
                    ClassName = `info`;
                    text = `ignored`;
                  }
                  else {
                    text = `unread`;
                  }
    
                  return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                    text
                  )}</span>`;
                },
              },
            ],
            actions: [
              // {
              //   title: this.$t("edit"),
              //   icon: "edit",
              //   type: "none",
              // },
              {
                title: this.$t("view"),
                icon: "eye",
                type: "none",
              },
              {
                title: this.$t("accepted"),
                icon: "share",
                type: "none",
              },
              {
                title: this.$t("ignored"),
                icon: "share",
                type: "none",
              },
              // {
              //   title: this.$t("delete"),
              //   icon: "trash",
              //   type: "none",
              // },
            ],
            filters: [
            //   {
            //     title: this.$t("date"),
            //     type: "range-picker",
            //     key: "date",
            //     option: ["today", "thisMonth", "last7Days", "nextYear"],
            //   },
            //   // {
            //   //   title: this.$t("age"),
            //   //   type: "range-filter",
            //   //   key: "age-range",
            //   //   maxTitle: this.$t("max_age"),
            //   //   minTitle: this.$t("min_age"),
            //   //   sign: "",
            //   // },
            //   {
            //     title: this.$t("documents"),
            //     type: "radio",
            //     key: "document_result",
            //     option: [
            //       { id: "1", value: "Folders" },
            //       { id: "0", value: "Files" },
            //     ],
            //     header: {
            //       title: this.$t("want_to_filter_your_list"),
            //       description: this.$t(
            //         "you_can_filter_your_data_table_which_are_created_based_on_gender"
            //       ),
            //     },
            //   },
            //   {
            //     title: this.$t("search_and_select"),
            //     type: "drop-down-filter",
            //     key: "search select",
            //     option: [],
            //   },
            //   {
            //     title: this.$t("my_document"),
            //     type: "checkbox",
            //     key: "document_type",
            //     option: [
            //       { id: "my_doc", value: "My Document" },
            //     ],
            //   },
            ],
            showFilter: false,
            showSearch: false,
            showCount: true,
            showClearFilter: true,
            paginationType: "pagination",
            responsive: true,
            rowLimit: 10,
            showAction: true,
            orderBy: "desc",
            actionType: "dropdown",
          },
        };
      },
      created() {
        this.options.columns = [...this.options.columns, this.actionObj];
        // this.preloader = true;
      },
      methods: {
        ignoreAll(){
          if(confirm('Are you sure you want to ignore all changes?')){
            return this.formChangeLogs(1,1,1,'ignore_all');
          }
        },
        getListAction(rowData, actionObj, active) {
          this.rowData = rowData;
           if (actionObj.title == this.$t("view")) {
            this.view(rowData);
          } 
          else if (actionObj.title == this.$t("accepted")) {
            var form_change_id = rowData.id;
            var form_id = rowData.form_revision_list.form_changes_name.id;
            var change_form_body_id = rowData.form_revision_list.form_body_id;
            this.formChangeLogs(change_form_body_id, form_id, form_change_id, actionObj.title);
          } else if (actionObj.title == this.$t("ignored")) {
            var form_change_id = rowData.id;
            var form_id = rowData.form_revision_list.form_changes_name.id;
            var change_form_body_id = rowData.form_revision_list.form_body_id;
            this.formChangeLogs(change_form_body_id, form_id, form_change_id, actionObj.title);
          }
          else {
            this.$toastr.w('You can not use this action for this document');
          }
          // else if (actionObj.title == this.$t("view")) {
          //   window.location = "/admin/documentlibrary/report";
          // }
        },
        view(rowData) {
          this.formType =  'view';
          this.formBody = rowData.form_revision_list.form_body_id;
          this.formRevisionId = rowData.form_revision_list.id;
          this.active = 2;
        },
        myFunction(rowData){
          let doc = document.getElementById(rowData.form_revision_list.id+'_'+rowData.form_revision_list.form_id+'_'+rowData.form_revision_list.form_body_id);
          if(doc){
            doc.addEventListener('click', () => {
              this.view(rowData);
            })
          }
        },
        previous() {
            this.active = 1;
        },
        formChangeLogs(change_form_body_id,form_id,form_change_id,status) {
            let data = {
                status: status,
                form_change_id: form_change_id,
                form_id: form_id,
                change_form_body_id: change_form_body_id,
            };
            axiosPost(actions.FORM_CHANGE_LOG, data)
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.$toastr.s(res.data.message);
                    }
                    else {
                        this.$toastr.i(res.data.message);
                    }
                })
                .catch((res) => {
                    this.$toastr.e(res.data.message);
                })
                .finally(() => {
                    this.$hub.$emit("reload-" + this.tableId);
                });
            },
        },
      mounted() {
        
      }, 
       computed: {
        userRole() {
          return this.$store.state.user.loggedInUser;
        },
        themeMode() {
          return this.$store.state.theme;
        },
      }
    };
    </script>
    